// eslint-disable-next-line import/no-extraneous-dependencies
import type { LenderIDType } from '@lendi-ui/lender-logos';

import { PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_LENDERS = 'PrismicGenericTemplateDataBodyLenders';

export interface GenericLendersPrimary {
  toggle_new_version: boolean;
  heading: TextFromRichText;
  subheading: TextFromRichText;
  more_link: TextFromRichText;
  more_link_url: PrismicLink;
  primary_button_text: TextFromRichText;
  primary_button_link: PrismicLink;
  secondary_button_text: TextFromRichText;
  secondary_button_link: PrismicLink;
}

export interface GenericLendersField {
  logo: LenderIDType;
}

export interface GenericLendersContent {
  __typename: typeof GENERIC_LENDERS;
  items: GenericLendersField[];
  primary: GenericLendersPrimary;
}
